import { Ghost } from '@phosphor-icons/react';

export default Ghost;
